export const mapMapMarker = (mapMarker): Content.MapMarker => {
	if (!mapMarker) {
		return null;
	}

	return {
		title: mapMarker.content.properties.title ?? null,
		text: mapMarker.content.properties.text?.markup ?? null,
		latitude: mapMarker.content.properties.latitude ?? null,
		longitude: mapMarker.content.properties.longitude ?? null,
	};
};

export const mapFirstMapMarker = (mapMarkers: { mapMarker }[]): Content.MapMarker => {
	if (!mapMarkers) {
		return null;
	}

	return mapMapMarker(mapMarkers.find((x) => x !== undefined));
};

export const mapMapMarkers = (mapMarkers: { mapMarker }[]): Content.MapMarker[] => {
	if (!mapMarkers) {
		return null;
	}

	return mapMarkers.map((mapMarker) => {
		return mapMapMarker(mapMarker);
	});
};
